export * from "./buy-cloud-org-setup-page.template";
export { BuyCloudOrgSetupPageTemplate as default } from "./buy-cloud-org-setup-page.template";
